import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

// The Slack messages a session proposed (ADR-039 8c), decided on its own page: read with its events, sent or rejected
// from its cards

export function useSlackProposals(serverId: string, sessionId: string, eventCount: number) {
  const api = useApiClient();
  return useQuery({
    // A new event may be a new proposal: read again when the session says more
    queryKey: ['slack-proposals', serverId, sessionId, eventCount],
    queryFn: () => api.outbox.slack(serverId, sessionId),
    select: (d) => d.proposals,
    placeholderData: (previous) => previous,
    // While one is being sent, until Slack answers
    refetchInterval: (q) => (q.state.data?.proposals.some((p) => p.status === 'sending') ? 3_000 : false),
  });
}

export function useDecideSlackProposal(serverId: string, sessionId: string) {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { id: string; send: true; text: string } | { id: string; send: false }) =>
      (v.send ? api.outbox.sendSlack(serverId, v.id, v.text) : api.outbox.rejectSlack(serverId, v.id)),
    onSettled: () => { void qc.invalidateQueries({ queryKey: ['slack-proposals', serverId, sessionId] }); },
  });
}
